import messages from "./messages.i18n";
import { useIntl } from "react-intl";
import ShareLinkToggleSwitch from "./SpaceShareLinkToggleSwitch";
import { PeekInputCheckbox } from "@piiqtechnologies/ui-components";
import ShareLinkProspect from "./SpaceShareLinkProspect";
export const SpaceShareLinkFormInitialValues = {
    isTracked: true,
    hideAddress: false,
    prospect: {
        _id: "",
        email: "",
        firstName: "",
        lastName: "",
    },
};
export const getSpaceShareLinkFormFields = (communityId) => {
    const intl = useIntl();
    return {
        listingConfig: [
            {
                id: "isTracked",
                label: intl.formatMessage(messages.spaceShareLinkFormTracking),
                placeholder: "",
                required: false,
                component: ShareLinkToggleSwitch,
                columns: 6,
            },
            {
                id: "hideAddress",
                label: intl.formatMessage(messages.spaceShareLinkFormHideAddress),
                placeholder: "",
                required: false,
                component: PeekInputCheckbox,
                type: "checkbox",
                style: { marginTop: "1.5rem" },
            },
        ],
        prospect: [
            {
                id: "prospect",
                label: intl.formatMessage(messages.spaceShareLinkFormProspect),
                placeholder: intl.formatMessage(messages.spaceShareLinkFormProspect),
                required: true,
                fullWidth: true,
                columns: 12,
                component: ShareLinkProspect,
                // @ts-ignore
                communityId,
            },
        ],
    };
};
